import { AppState } from '../state'
import { Geografi, Parti } from '../../domain'
import { idFrom } from '../../api'
import { NotFoundError } from '../../routes/errors'

export function selectGeografi(state: AppState, paramId: string): Geografi | never {
  const geografi = state.grunndata.geografi.find(geografi => idFrom(geografi) === paramId)
  if (geografi) {
    return geografi
  }
  throw new NotFoundError(`Fant ikke geografi ${paramId}`)
}

export function selectParti(state: AppState, paramId: string): Parti | never {
  const parti = state.grunndata.parti.find(parti => parti.id === paramId)
  if (parti) {
    return parti
  }
  throw new NotFoundError(`Fant ikke parti ${paramId}`)
}
